export default "__VITE_ASSET__HgJMFn1R__"